class UserStore {
    constructor() {
        if (!UserStore.instance) {
            this._data = {};
            UserStore.instance = this;
        }

        return UserStore.instance;
    }

    add(data) {
        Object.assign(this._data, data);
    }

    get() {
        return this._data;
    }

    isLoggedIn() {
        return Object.keys(this._data).length === 0 ? false : true;
    }

}

const instance = new UserStore();
Object.freeze(instance);

export default instance;


// WEBPACK FOOTER //
// ./src/components/UserStore/index.js